import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import Themes from "./themes";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'

const isProd = Boolean(window.location.hostname === 'pub.adireto.com');
let uri = isProd ? "https://api.adireto.com/graphql" : "https://api-staging.adireto.com/graphql";

const client = new ApolloClient({
  uri: uri,
  request: (operation) => {
    const token = localStorage.getItem('id_token')
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : '',
        system: 'Pub'
      }
    })
  }
});

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
      <ThemeProvider theme={Themes.default}>
        <CssBaseline />
        <ApolloProvider client={client}>
          <ApolloHooksProvider client={client}>
          <App/>
          </ApolloHooksProvider>
        </ApolloProvider>
      </ThemeProvider>
    </UserProvider>
  </LayoutProvider>
  ,
  
  document.getElementById("root"),
);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
